import { useFormContext, useWatch } from "react-hook-form";

import { cn } from "@bentolabs/kit/utils";
import { formatCurrency } from "@bentolabs/kit/web3";

import basketAssets from "shared/assets/basket-assets.svg";
import { Badge } from "shared/ui/badge";
import { WithdrawFormType } from "widgets/trade/types";

import { PreviewRow } from "../preview-row";
import { BasketAssetsDetails } from "./basket-assets-details";

type Props = {
  className?: string;
};

export const ResultsPreview = ({ className }: Props) => {
  const { setValue, control } = useFormContext<WithdrawFormType>();
  const type = useWatch({ control, name: "type" });
  const toCurrency = useWatch({ control, name: "toCurrency" });
  const toValue = useWatch({ control, name: "toValue" });

  return (
    <div className={cn("flex flex-col gap-1.5", className)}>
      <PreviewRow
        title={`${formatCurrency(toValue)} ${toCurrency?.symbol}`}
        image={toCurrency?.logoURI}
        badge={<Badge className="text-ultramarine-blue">No slippage</Badge>}
        isActive={type === "delay"}
        durationDescription="7 days"
        onClick={() => {
          setValue("type", "delay");
        }}
      />
      <PreviewRow
        title="Basket of Assets"
        image={basketAssets}
        isActive={type === "basket"}
        durationDescription="Instant"
        onClick={() => {
          setValue("type", "basket");
        }}
      >
        <BasketAssetsDetails />
      </PreviewRow>
    </div>
  );
};
